module.exports = __webpack_public_path__ + "img/21.6c83c51d.png";